import { render, staticRenderFns } from "./TimberTableFullResults.vue?vue&type=template&id=1f2007f0&scoped=true&"
import script from "./TimberTableFullResults.vue?vue&type=script&lang=js&"
export * from "./TimberTableFullResults.vue?vue&type=script&lang=js&"
import style0 from "./TimberTableFullResults.vue?vue&type=style&index=0&id=1f2007f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2007f0",
  null
  
)

export default component.exports